"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelSeparator = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const PanelSeparator = () => (react_1.default.createElement("div", { style: {
        display: "flex",
        flexDirection: "row",
    } },
    react_1.default.createElement("div", { style: { width: "1px", height: "100%", background: "#1a1a1a" } }),
    react_1.default.createElement("div", { style: { width: "6px", height: "100%", background: "#282828" } }),
    react_1.default.createElement("div", { style: { width: "1px", height: "100%", background: "#5c5c5c" } })));
exports.PanelSeparator = PanelSeparator;
//# sourceMappingURL=index.js.map